import React, { Component } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { obfuscatedCoordinates, calculateZoomForRadius } from '../../util/maps';
import { Heading, Map } from '../../components';

import css from './ListingPage.module.css';

/**
 * The SectionMapMaybe component.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {propTypes.latlng} [props.geolocation] - The geolocation
 * @param {propTypes.uuid} props.listingId - The listing id
 * @returns {JSX.Element} section map maybe component
 */
class SectionMapMaybe extends Component {
  constructor(props) {
    super(props);
    this.state = { isStatic: true };
  }

  render() {
    const { className, rootClassName, geolocation, publicData, listingId, mapsConfig, currentUser } = this.props;

    if (!geolocation) {
      return null;
    }

    // Always try to get the most up-to-date listing data from the Redux store
    // This ensures we have the correct radius even when navigating from search results
    let finalPublicData = publicData;
    
    if (listingId) {
      // First try to get the listing from the main listings store
      const listing = this.props.getListing?.(listingId);
      if (listing && listing.attributes?.publicData?.location?.radius) {
        finalPublicData = listing.attributes.publicData;
      } else if (currentUser) {
        // If not found in main store and user is logged in, try own listings
        const ownListing = this.props.getOwnListing?.(listingId);
        if (ownListing && ownListing.attributes?.publicData?.location?.radius) {
          finalPublicData = ownListing.attributes.publicData;
        }
      }
    }

    const address = finalPublicData && finalPublicData.location ? finalPublicData.location.address : '';
    const classes = classNames(rootClassName || css.sectionMap, className);
    const cacheKey = listingId ? `${listingId.uuid}_${geolocation.lat}_${geolocation.lng}` : null;

    // Get the listing's radius in kilometers, default to 20 if not set
    const listingRadiusKm = finalPublicData?.location?.radius || 20;
    // Convert kilometers to meters for the map
    const listingRadiusMeters = listingRadiusKm * 1000;

    // Calculate appropriate zoom level for the listing's radius
    const calculatedZoom = calculateZoomForRadius(listingRadiusMeters);



    // Create a custom mapsConfig with the listing's radius and calculated zoom
    const customMapsConfig = {
      ...mapsConfig,
      fuzzy: {
        ...mapsConfig.fuzzy,
        offset: listingRadiusMeters,
        defaultZoomLevel: calculatedZoom,
      },
    };

    const mapProps = mapsConfig.fuzzy.enabled
      ? { 
          obfuscatedCenter: obfuscatedCoordinates(geolocation, listingRadiusMeters, cacheKey),
          mapsConfig: customMapsConfig,
          zoom: calculatedZoom
        }
      : { address, center: geolocation, mapsConfig: customMapsConfig, zoom: calculatedZoom };
    const map = <Map {...mapProps} useStaticMap={this.state.isStatic} />;

    return (
      <section className={classes} id="listing-location">
        {/* <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
          <FormattedMessage id="ListingPage.locationTitle" />
        </Heading> */}

        {this.state.isStatic ? (
          <button
            className={css.map}
            onClick={() => {
              this.setState({ isStatic: false });
            }}
          >
            {map}
          </button>
        ) : (
          <div className={css.map}>{map}</div>
        )}
      </section>
    );
  }
}

export default SectionMapMaybe;
